import { RouteHelper } from "@app/helpers/route-helper.ts";
import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
    beforeLoad: RouteHelper.AuthGuard,
    component: () => <Navigate to={"/entry/time"} />,
});
